
export function EncodeUrl(value, isParam) {
  if (value)
    if (isParam)
      return encodeURIComponent(value.toString().toLowerCase());
    else
      return encodeURIComponent(value.toString().toLowerCase().replace("+", "-plus-"));
  return value;
};

export function DecodeUrl(value, isParam) {
  if (value)
    if (isParam)
      return decodeURIComponent(value);
    else
      return decodeURIComponent(value).replace("-plus-", "+");
  return value;
};

export function MapUrlToTemplate(urlTemplate, location) {
  var urlResolved = {};
  var _url = new URL(location);
  var urlPathTemplate = Array.from(urlTemplate.split('?')[0].matchAll(/(?:\{)([^\}]*)(?:\})/g)).map(v => v[1])
  var urlQueryTemplate = urlTemplate.includes("?") ? Array.from(urlTemplate.split('?')[1].matchAll(/(?:\{)([^\}]*)(?:\})/g)).map(v => v[1]) : [];
  _url.pathname.split("/").filter(v => v).forEach((v, i) => {
    if (urlPathTemplate[i]) {
      urlResolved[urlPathTemplate[i]] = DecodeUrl(v);
    }
  });
  var i = 0;
  _url.searchParams.forEach((v, k) => {
    if (urlQueryTemplate[i]) {
      urlResolved[urlQueryTemplate[i]] = DecodeUrl(v);//v;
    }
    i++;
  });

  //console.log("!!!urlResolved", urlResolved);

  return urlResolved;
};

export function MapQueryStringToObject(location) {
  var ret = {};
  var _url = new URL(location);
  _url.searchParams.forEach((v, k) => {
    ret[k] = (ret[k] || "") != "" ? ret[k] + "," + v : v;
  });

  return ret;
};

export function ObjectToQueryString(object,options) {
  var ret = "";

  options = Object.assign({
    encode: true,
    strict: true,
    arrayFormat: 'none',
    arrayFormatSeparator: ','
  }, options);

  const encode = (value, options) => {
    if (options.encode) {
      return encodeURIComponent(value);
    }

    return value;
  }

  const formatter = key => (result, value) => {
    if (
      value === undefined ||
      (options.skipNull && value === null) ||
      (options.skipEmptyString && value === '')
    ) {
      return result;
    }

    if (value === null) {
      return [...result, encode(key, options)];
    }

    return [...result, [encode(key, options), '=', encode(value, options)].join('')];
  };

  ret = Object.keys(object).map((key) => {
    const value = object[key];

    if (Array.isArray(value)) {
      return value
        .reduce(formatter(key), [])
        .join('&');
    }

    return encode(key, options) + '=' + encode(value, options)
  }).join('&');

  return ret;
};

